<div [formGroup]="form" class="w-full">
    <div class="iv-fieldsets">
        <!-- Traverse da sostituire (uguale per tutti i tipi) -->
        <div>
            <div class="iv-subgroup-title">Traverse da sostituire (%)</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Telaio</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="traverseSostTelaio" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Intermedia</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="traverseSostIntermedia" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Cuore</label>
                    <app-segmented-select [options]="opzioniStatoUsura" formControlName="traverseSostCuore" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
            </div>
        </div>

        <!-- Legnami: SS = ...Sost..., SD/SI = ...Scorr... -->
        <div>
            <div class="iv-subgroup-title">Legnami fatti scorrere (%)</div>
            <div class="iv-rows">
                <div class="iv-row">
                    <label>Telaio</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="(tipoScambio === 'SS' ? 'legnamiSost' : 'legnamiScorr') + 'Telaio'" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Intermedia</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="(tipoScambio === 'SS' ? 'legnamiSost' : 'legnamiScorr') + 'Intermedia'" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
                <div class="iv-row">
                    <label>Cuore</label>
                    <app-segmented-select [options]="opzioniStatoUsura" [formControlName]="(tipoScambio === 'SS' ? 'legnamiSost' : 'legnamiScorr') + 'Cuore'" palette="percent" [wrap]="true"></app-segmented-select>
                </div>
            </div>
        </div>
    </div>

    <!-- Note traverse comuni -->
    <div class="mt-4">
        <textarea rows="3" pTextarea formControlName="traverseNote" class="w-full" placeholder="Note traverse/legnami"></textarea>
    </div>
</div>
